import React from "react";
import { useEffect } from "react";
import Gh from "../assets/github.svg";
import LinkedIn from "../assets/LinkedIn.png";
import Twitter from "../assets/Twitter.png";
import Angellist from "../assets/angellist.png";
import "./mobile_socials.css";
import { gsap } from "gsap/all";

const Mobile_socials = () => {
  useEffect(() => {
    // gsap.to(".socials-wrapper", {
    //   duration: 2,
    //   x: "-50%",
    //   opacity: 1,
    //   delay: 2,
    //   scrollTrigger: {
    //     trigger: ".socials-wrapper",
    //   },
    // });
    // gsap.to(".socials-hide", {
    //   duration: 2,
    //   x: "50%",
    //   opacity: 1,
    //   delay: 2,
    //   scrollTrigger: {
    //     trigger: ".socials-wrapper",
    //   },
    // });
  }, []);
  return (
    <>
      <div className="socials-hide"></div>
      <div className="socials-wrapper">
        <div className="github-social">
          <a
            href="https://github.com/codedit334"
            target="_blank"
            rel="noreferrer"
          >
            <img src={Gh} alt="github" />
          </a>
        </div>
        <div className="linkedIn-social">
          <a
            href="https://www.linkedin.com/in/oussama-elabdioui-4677a41b6/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={LinkedIn} alt="linkedIn" />
          </a>
        </div>
        <div className="twitter-social">
          <a
            href="https://twitter.com/home?lang=en"
            target="_blank"
            rel="noreferrer"
          >
            <img src={Twitter} alt="twitter" />
          </a>
        </div>
        <div className="angellist-social">
          <a href="https://wellfound.com/u/oussama-elabdioui">
          <img src={Angellist} alt="Angellist" />
          </a>
        </div>
      </div>
    </>
  );
};

export default Mobile_socials;
